import React from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Avatar,
  Typography,
} from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  profileContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: `0 ${theme.spacing.unit}px`,
    cursor: 'pointer',
  },
  profileAvatarRoot: {
    flex: '0 0 auto',
    marginRight: theme.spacing.unit * 1.5,
  },
  profileInfo: {
    flex: '1 1 auto',
  },
  userName: {
    textTransform: 'capitalize',
  },
  roleName: {
    textTransform: 'uppercase',
  },
  inlineProfileContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: `0 ${theme.spacing.unit}px`,
    '& *': {
      flex: '0 0 auto',
    },
  },
  inlineProfileTitle: {
    flex: '1 1 auto',
  }
});

//@ts-ignore
interface MyPATProfileBoxProps extends WithStyles<typeof styles> {
  classes: any,
  avatarProps: any,
  profileBoxProps: object,
  profileTitleProps: object,
  profileCaptionProps: object,
  title: string,
  caption: string,
  variant: string,
};

const MyPATProfileBox = (props: MyPATProfileBoxProps) => {
  const {
    classes,
    avatarProps,
    profileBoxProps,
    profileTitleProps = {
      variant: 'body1',
      noWrap: true,
    },
    profileCaptionProps = {
      variant: 'caption',
      noWrap: true,
      color: 'textSecondary',
    },
    title,
    caption,
    variant = 'box'
  } = props;

  if (!avatarProps.src) {
    avatarProps.src = "assets/img/profile-default.png";
  }

  if (_.isEqual(variant, 'inline')) {
    return (
      <div className={classes.inlineProfileContainer} {...profileBoxProps}>
        <Avatar {...avatarProps} classes={{ root: classes.profileAvatarRoot }} />
        <Typography className={classes.inlineProfileTitle} {...profileTitleProps}>{title}</Typography>
        {_.isEmpty(caption) ||
          <Typography {...profileCaptionProps}>{caption}</Typography>
        }
      </div>
    );
  }
  return (
    <div className={classes.profileContainer} {...profileBoxProps}>
      <Avatar {...avatarProps} classes={{ root: classes.profileAvatarRoot }} />
      <div className={classes.profileInfo}>
        <Typography className={classes.userName} {...profileTitleProps}>{title}</Typography>
        {_.isEmpty(caption) ||
          <Typography className={classes.roleName} {...profileCaptionProps}>{caption}</Typography>
        }
      </div>
    </div>
  );
};

//@ts-ignore
export default withStyles(styles)(MyPATProfileBox);